import React from 'react';
const services = ['studie a konzultace', 'projekce', 'projektové řízení', 'realizace', 'SW a IT', 'servis a podpora', 'market focus'];
export function ServicesSolutions() {
  return <section id="sluzby" className="w-full bg-white py-12" data-id="element-195">
      <div className="max-w-6xl mx-auto px-6" data-id="element-196">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.6fr] gap-16 items-start" data-id="element-197">
          {/* Left Column - Services List */}
          <div className="flex flex-col items-end text-right" data-id="element-198">
            <h2 className="text-2xl font-normal text-[#707070] tracking-wide mb-8" data-id="element-199">
              SLUŽBY
            </h2>
            <ul className="space-y-2" data-id="element-200">
              {services.map(service => <li key={service} data-id="element-201">
                  <a href="#" className="flex items-center justify-end gap-3 text-[#707070] hover:text-[#404040] transition-colors group py-1" data-id="element-202">
                    <span className="text-base" data-id="element-203">{service}</span>
                    <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 group-hover:opacity-100 transition-opacity scale-x-[-1]" data-id="element-204" />
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Right Column - Image (cropped top white space) */}
          <div className="w-full overflow-hidden" data-id="element-205">
            <img src="https://cdn.magicpatterns.com/uploads/aFeewvzHWGmK4RBHjKzj43/42123269-4b82-40b2-9854-890acd95888e.png" alt="Služby - konzultace a podpora" className="w-full h-auto grayscale -mt-8" data-id="element-206" />
          </div>
        </div>
      </div>
    </section>;
}